import React from 'react';
import {
    SimpleForm,
    TextInput,
    NumberInput,
    CreateButton
} from 'react-admin';
import {
    EditNode,
    EditNodeToolbar,
    TreeWithDetails,
} from '@react-admin/ra-tree';
import HierarchyEdit from './HierarchyEdit';

// export const BusinessUnitEdit = () => (
//     <EditNode>
//         <SimpleForm toolbar={<EditNodeToolbar />}>
//             <NumberInput source="id" /> 
//             <TextInput source="text" />
//             <NumberInput source="parent_id" /> 
//         </SimpleForm>
//     </EditNode>
// );

export const BusinessUnitList = () => {
    const EditComponet = HierarchyEdit
    return (
        <TreeWithDetails
            titleField='text' 
            linkTo="edit"
            allowMultipleRoots
            edit={EditComponet}
            nodeActions={<div></div>}
            addRootButton={<CreateButton label="Add Business Unit Root" />}
        />
    )};

export default BusinessUnitList;

